import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"

export type ButtonType =
  | "primary"
  | "primaryNeon"
  | "secondary"
  | "secondaryBorder"
export type ButtonSize = "md" | "lg" | "xl" | "xxl"
export type ButtonTarget = "_blank" | "_self"

export interface ButtonProps {
  children: React.ReactNode | string
  className?: string
  halo?: boolean
  href?: string
  onClick?: () => void
  size?: ButtonSize
  target?: ButtonTarget
  to?: string
  type?: ButtonType
}

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  halo,
  href,
  onClick,
  size,
  target,
  to,
  type,
}) => {
  const DynamicElement = href ? "a" : "button"
  const elementClassname = cx({
    [styles.button]: true,
    [styles.md]: size === "md",
    [styles.lg]: size === "lg",
    [styles.xl]: size === "xl",
    [styles.xxl]: size === "xxl",
    [styles.primary]: type === "primary",
    [styles.primaryNeon]: type === "primaryNeon",
    [styles.secondary]: type === "secondary",
    [styles.secondaryBorder]: type === "secondaryBorder",
    [styles.halo]: halo,
    [className]: !!className,
  })
  return (
    <>
      {to && (
        <Link
          to={to}
          className={elementClassname}
          onTouchStart={() => {
            return true
          }}
        >
          {children}
        </Link>
      )}
      {!to && (
        <DynamicElement
          className={elementClassname}
          target={href && target ? target : null}
          onClick={onClick}
          rel={href && "noopener noreferrer"}
          onTouchStart={() => {
            return true
          }}
        >
          {children}
        </DynamicElement>
      )}
    </>
  )
}

export default Button
